(() => {
  const ROOT_ATTR = 'data-kol';
  const MOTION_ATTR = 'data-kol-motion';
  const STATIC_ATTR = 'data-kol-static';
  const DONE_ATTR = 'data-kol-done';
  const RETRY_MS = 80;
  const RETRY_MAX = 40;

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showStatic = (root) => {
    if (root) root.setAttribute(STATIC_ATTR, '');
  };

  const uniqueCards = (root) =>
    Array.prototype.filter.call(root.querySelectorAll('[data-kol-card]'), (card) => {
      return !card.classList.contains('swiper-slide-duplicate');
    });

  const visibleCards = (cards) =>
    cards.filter((card) => {
      const rect = card.getBoundingClientRect();
      return rect.width > 8 && rect.right > 0 && rect.left < window.innerWidth;
    });

  const revealAll = (root) => {
    const clones = root.querySelectorAll('.swiper-slide-duplicate');
    if (clones.length) gsap.set(clones, { autoAlpha: 1 });
  };

  const destroyMotion = (root) => {
    if (!root) return;
    if (root._kolRetry) {
      window.clearTimeout(root._kolRetry);
      root._kolRetry = null;
    }
    if (root._kolCtx) {
      root._kolCtx.revert();
      root._kolCtx = null;
    }
    root.removeAttribute(MOTION_ATTR);
    root.removeAttribute(STATIC_ATTR);
    root.removeAttribute(DONE_ATTR);
  };

  const setupMotion = (root, attempt) => {
    if (!root || root.hasAttribute(MOTION_ATTR)) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if ((attempt || 0) < RETRY_MAX) {
        root._kolRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
        return;
      }
      showStatic(root);
      return;
    }

    const swiperEl = root.querySelector('.kol-swiper');
    if (swiperEl && !swiperEl.swiper) {
      if ((attempt || 0) < RETRY_MAX) {
        root._kolRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
        return;
      }
    }

    gsap.registerPlugin(ScrollTrigger);
    root.setAttribute(MOTION_ATTR, '');

    if (prefersReducedMotion()) {
      showStatic(root);
      return;
    }

    const heading = root.querySelector('[data-kol-heading]');
    const cards = uniqueCards(root);
    if (!heading && !cards.length) return;

    root._kolCtx = gsap.context(() => {
      if (heading) gsap.set(heading, { autoAlpha: 0, y: 12 });
      if (cards.length) gsap.set(cards, { autoAlpha: 0, y: 12 });
      gsap.set(root.querySelectorAll('.swiper-slide-duplicate'), { autoAlpha: 0 });

      const incoming = visibleCards(cards);
      const playCards = incoming.length ? incoming : cards;
      const parts = [];
      if (heading) parts.push(heading);
      playCards.forEach((card) => parts.push(card));
      if (!parts.length) return;

      gsap.to(parts, {
        autoAlpha: 1,
        y: 0,
        duration: 0.4,
        stagger: 0.04,
        ease: 'power1.out',
        overwrite: true,
        scrollTrigger: {
          trigger: root,
          start: 'top 90%',
          once: true
        },
        onComplete: () => {
          gsap.set(parts, { clearProps: 'transform' });
          revealAll(root);
          root.setAttribute(DONE_ATTR, '');
        }
      });
    }, root);
  };

  const scan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach((root) => setupMotion(root, 0));
  };

  const rescan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach(destroyMotion);
    scan();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(`[${ROOT_ATTR}]`);
    if (root) destroyMotion(root);
  });
})();
